import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonMessages } from '@app/constants/common.messages';
import { CompanyFeatures } from '@app/models/company-features.model';
import { ButtonType } from '@app/shared/components/inputs/button/button.component';
import { Globals } from '@app/shared/globals/globals';

@Component({
  selector: 'app-restricted-state',
  templateUrl: './restricted-state.component.html',
  styleUrls: ['./restricted-state.component.scss']
})
export class RestrictedStateComponent {

  protected readonly eCommonMessages = CommonMessages;
  protected readonly eButtonType = ButtonType;

  @Input() heading!: string;
  @Input() message!: string;

  constructor(
    private globals: Globals,
    private router: Router
  ) { }

  get peopleDirectoryAvailable(): boolean {
    return this.globals.hasFeature(CompanyFeatures.PEOPLE_DIRECTORY);
  }

  goToPeopleDirectory(): void {
    this.router.navigate(['/people-directory']);
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}
